var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.localUser
    ? _c("div", { staticClass: "row m-0 user_profile_block" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Имя")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:1|max:255",
                      expression: "'required|min:1|max:255'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localUser.name,
                      expression: "localUser.name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    name: "user_name",
                    placeholder: "Имя пользователя",
                    "data-vv-as": "Имя пользователя",
                  },
                  domProps: { value: _vm.localUser.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.localUser, "name", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.has("user_name")
                  ? _c("small", { staticClass: "form-text text-danger" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errors.first("user_name")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Логин")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:1|max:255",
                      expression: "'required|min:1|max:255'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localUser.login,
                      expression: "localUser.login",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    name: "user_login",
                    placeholder: "Логин пользователя",
                    "data-vv-as": "Логин пользователя",
                  },
                  domProps: { value: _vm.localUser.login },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.localUser, "login", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.has("user_login")
                  ? _c("small", { staticClass: "form-text text-danger" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errors.first("user_login")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Пароль")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:1|max:255",
                      expression: "'required|min:1|max:255'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localUser.password,
                      expression: "localUser.password",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "password",
                    name: "password",
                    "data-vv-as": "Пароль пользователя",
                    placeholder: "Пароль",
                  },
                  domProps: { value: _vm.localUser.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.localUser, "password", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.has("password")
                  ? _c("small", { staticClass: "form-text text-danger" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errors.first("password")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Подтверждение пароля"),
                ]),
                _vm._v(" "),
                !_vm.localUser.id
                  ? _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|min:1|max:255",
                          expression: "'required|min:1|max:255'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localUser.password_repeat,
                          expression: "localUser.password_repeat",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "password",
                        name: "user_pass_repeat",
                        "data-vv-as": "Пароль пользователя",
                        placeholder: "Подтверждение пароля",
                      },
                      domProps: { value: _vm.localUser.password_repeat },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.localUser,
                            "password_repeat",
                            $event.target.value
                          )
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.localUser.password_repeat,
                          expression: "localUser.password_repeat",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        placeholder: "Подтверждение пароля",
                        type: "password",
                      },
                      domProps: { value: _vm.localUser.password_repeat },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.localUser,
                            "password_repeat",
                            $event.target.value
                          )
                        },
                      },
                    }),
                _vm._v(" "),
                _vm.errors.has("user_pass_repeat")
                  ? _c("small", { staticClass: "form-text text-danger" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errors.first("user_pass_repeat")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("label", { attrs: { for: "" } }, [_vm._v("Телеграм")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm.details.telegram_chat_data &&
                  _vm.details.telegram_chat_data.details
                    ? [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.details.telegram_chat_data.details.chat_id,
                              expression:
                                "details.telegram_chat_data.details.chat_id",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", disabled: "" },
                          domProps: {
                            value:
                              _vm.details.telegram_chat_data.details.chat_id,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.telegram_chat_data.details,
                                "chat_id",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "input-group-prepend input-group-append",
                          },
                          [
                            _c("LoadingButton", {
                              attrs: {
                                title: '<i class="icon-fa icon-fa-remove"></i>',
                                type: "button",
                                className: "btn btn-outline-danger",
                                loading: _vm.removeDetailBtnLoading,
                                color: _vm.$constants.DANGER_COLOR,
                                onClick: () =>
                                  _vm.removeDetail(
                                    _vm.details.telegram_chat_data.id,
                                    "telegram"
                                  ),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    : [
                        _c("div", [
                          _c("p", { staticClass: "mb-1" }, [
                            _vm._v("Подключение пользователя к боту"),
                          ]),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          !_vm.authorizeTelegram
                            ? _c(
                                "div",
                                [
                                  _c("LoadingButton", {
                                    attrs: {
                                      title: "Подключить",
                                      className: "btn btn-outline-info btn-sm",
                                      onClick: _vm.addToBot,
                                      loading: _vm.telegramAuthLoading,
                                      color: _vm.$constants.SUCCESS_COLOR,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c("div", [
                                _vm._m(2),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Нажмите Start и отправьте боту код "),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.telegramCode)),
                                  ]),
                                ]),
                              ]),
                        ]),
                      ],
                ],
                2
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Телефон")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localUser.phone,
                      expression: "localUser.phone",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.localUser.phone },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.localUser, "phone", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("E-mail")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email|max:255",
                      expression: "'required|email|max:255'",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localUser.email,
                      expression: "localUser.email",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    name: "user_email",
                    "data-vv-as": "E-mail пользователя",
                    placeholder: "E-mail",
                  },
                  domProps: { value: _vm.localUser.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.localUser, "email", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.errors.has("user_email")
                  ? _c("small", { staticClass: "form-text text-danger" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.errors.first("user_email")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.$AllCities
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Город")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.localUser.extra_data.city_id,
                            expression: "localUser.extra_data.city_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.localUser.extra_data,
                              "city_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _vm._l(_vm.$AllCities, function (city) {
                          return _c(
                            "option",
                            { domProps: { value: city.id } },
                            [_vm._v(_vm._s(city.name))]
                          )
                        }),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "0" } }, [
                          _vm._v("Другой город"),
                        ]),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Тип доступа")]),
                  _vm._v(" "),
                  _c("multiselect", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    attrs: {
                      name: "user_role",
                      options: _vm.roles,
                      "data-vv-as": "Роль пользователя",
                      "track-by": "name",
                      label: "name_title",
                      "show-labels": false,
                      placeholder: "Выберите тип доступа",
                      multiple: true,
                    },
                    model: {
                      value: _vm.localUser.roles,
                      callback: function ($$v) {
                        _vm.$set(_vm.localUser, "roles", $$v)
                      },
                      expression: "localUser.roles",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.has("user_role")
                    ? _c("small", { staticClass: "form-text text-danger" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errors.first("user_role")) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Дополнительные метки"),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    staticClass: "extra_labels",
                    attrs: {
                      options: _vm.tags,
                      "track-by": "tag",
                      label: "tag",
                      "show-labels": false,
                      placeholder: "Выберите метку",
                      multiple: true,
                    },
                    model: {
                      value: _vm.details.user_tags.details,
                      callback: function ($$v) {
                        _vm.$set(_vm.details.user_tags, "details", $$v)
                      },
                      expression: "details.user_tags.details",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Комментарий")]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.details.comment.details,
                      expression: "details.comment.details",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    rows: "3",
                    placeholder: "Дополнительный сведения пользователя",
                  },
                  domProps: { value: _vm.details.comment.details },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.details.comment,
                        "details",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _vm.extraOptionsByAlias("divisionSelect")
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [_vm._v("Дивизион")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.details.division_id.details,
                            expression: "details.division_id.details",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.details.division_id,
                                "details",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.updateCitiesArray,
                          ],
                        },
                      },
                      _vm._l(_vm.$AllDivisions, function (div) {
                        return _c("option", { domProps: { value: div.id } }, [
                          _vm._v(_vm._s(_vm.mixinGetDivisionName(div))),
                        ])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.extraOptionsByAlias("workingShifts")
                ? _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Доступные рабочие смены"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.details.day_shift_num.details,
                              expression: "details.day_shift_num.details",
                            },
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.details.day_shift_num,
                                "details",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { disabled: "", value: "0" } },
                            [_vm._v("Выберите смену")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.dayShifts, function (dayShift) {
                            return _c(
                              "option",
                              { domProps: { value: dayShift.id } },
                              [_vm._v(_vm._s(dayShift.title))]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Доступные рабочие смены"),
                      ]),
                      _vm._v(" "),
                      _c("multiselect", {
                        attrs: {
                          options: _vm.$AllWorkingShifts,
                          "track-by": "title",
                          label: "title",
                          "show-labels": false,
                          "custom-label": _vm.shiftLabel,
                          placeholder: "Выберите смену",
                          multiple: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "singleLabel",
                              fn: function (props) {
                                return [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(props) +
                                      "!\n            "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "option",
                              fn: function (props) {
                                return [
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.shiftLabel(props))),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1938556412
                        ),
                        model: {
                          value: _vm.details.working_shifts.details,
                          callback: function ($$v) {
                            _vm.$set(_vm.details.working_shifts, "details", $$v)
                          },
                          expression: "details.working_shifts.details",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.extraOptionsByAlias("assistToManager")
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Помощник менеджера"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.details.assist_to_user.details,
                            expression: "details.assist_to_user.details",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.details.assist_to_user,
                              "details",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.managers, function (manager, id) {
                        return _c("option", { domProps: { value: id } }, [
                          _vm._v(_vm._s(manager)),
                        ])
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.extraOptionsByAlias("useBackPacks")
                ? _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.details.use_backpack_system.details,
                          expression: "details.use_backpack_system.details",
                        },
                      ],
                      attrs: { type: "checkbox", id: "ext_che_1" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.details.use_backpack_system.details
                        )
                          ? _vm._i(
                              _vm.details.use_backpack_system.details,
                              null
                            ) > -1
                          : _vm.details.use_backpack_system.details,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.details.use_backpack_system.details,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.details.use_backpack_system,
                                  "details",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.details.use_backpack_system,
                                  "details",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.details.use_backpack_system,
                              "details",
                              $$c
                            )
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "pointer", attrs: { for: "ext_che_1" } },
                      [_vm._v("Использовать систему рюкзаков")]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.extraOptionsByAlias("runnerReportDays")
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Количество дней для отчета"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.details.runner_report_days.details,
                          expression: "details.runner_report_days.details",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "number" },
                      domProps: {
                        value: _vm.details.runner_report_days.details,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.details.runner_report_days,
                            "details",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.extraOptionsByAlias("tablet_imei")
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("IMEI планшета"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.details.tablet_imei.details,
                          expression: "details.tablet_imei.details",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.details.tablet_imei.details },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.details.tablet_imei,
                            "details",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("p", [_vm._v("Страница отчета")]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.details.hide_report_blocks.details.expenses,
                        expression:
                          "details.hide_report_blocks.details.expenses",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.details.hide_report_blocks.details.expenses
                      )
                        ? _vm._i(
                            _vm.details.hide_report_blocks.details.expenses,
                            null
                          ) > -1
                        : _vm.details.hide_report_blocks.details.expenses,
                    },
                    on: {
                      change: function ($event) {
                        var $$a =
                            _vm.details.hide_report_blocks.details.expenses,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "expenses",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "expenses",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.details.hide_report_blocks.details,
                            "expenses",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v('\n            скрыть блок "расходы"\n          '),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.details.hide_report_blocks.details
                            .runnerInCashment,
                        expression:
                          "details.hide_report_blocks.details.runnerInCashment",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.details.hide_report_blocks.details.runnerInCashment
                      )
                        ? _vm._i(
                            _vm.details.hide_report_blocks.details
                              .runnerInCashment,
                            null
                          ) > -1
                        : _vm.details.hide_report_blocks.details
                            .runnerInCashment,
                    },
                    on: {
                      change: function ($event) {
                        var $$a =
                            _vm.details.hide_report_blocks.details
                              .runnerInCashment,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "runnerInCashment",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "runnerInCashment",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.details.hide_report_blocks.details,
                            "runnerInCashment",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(
                    '\n            скрыть блок "инкассации курьеров"\n          '
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.details.hide_report_blocks.details.inCash,
                        expression: "details.hide_report_blocks.details.inCash",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.details.hide_report_blocks.details.inCash
                      )
                        ? _vm._i(
                            _vm.details.hide_report_blocks.details.inCash,
                            null
                          ) > -1
                        : _vm.details.hide_report_blocks.details.inCash,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.details.hide_report_blocks.details.inCash,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "inCash",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "inCash",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.details.hide_report_blocks.details,
                            "inCash",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v('\n            скрыть блок "касса"\n          '),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.details.hide_report_blocks.details.reportHistory,
                        expression:
                          "details.hide_report_blocks.details.reportHistory",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(
                        _vm.details.hide_report_blocks.details.reportHistory
                      )
                        ? _vm._i(
                            _vm.details.hide_report_blocks.details
                              .reportHistory,
                            null
                          ) > -1
                        : _vm.details.hide_report_blocks.details.reportHistory,
                    },
                    on: {
                      change: function ($event) {
                        var $$a =
                            _vm.details.hide_report_blocks.details
                              .reportHistory,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "reportHistory",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.details.hide_report_blocks.details,
                                "reportHistory",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.details.hide_report_blocks.details,
                            "reportHistory",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(
                    '\n            скрыть блок "сальдо прошлого дня"\n          '
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _vm.hasRole("runner") || _vm.hasRole("chiefRunner")
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("ФИО для доверенности"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.details.documents_data.details.name_s,
                              expression:
                                "details.documents_data.details.name_s",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: {
                            value: _vm.details.documents_data.details.name_s,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.documents_data.details,
                                "name_s",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Паспортные данные"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.details.documents_data.details.passport,
                              expression:
                                "details.documents_data.details.passport",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: {
                            value: _vm.details.documents_data.details.passport,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.documents_data.details,
                                "passport",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Данные доверенности"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.details.documents_data.details
                                  .agreement_date,
                              expression:
                                "details.documents_data.details.agreement_date",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: {
                            value:
                              _vm.details.documents_data.details.agreement_date,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.documents_data.details,
                                "agreement_date",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Прописка"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.details.documents_data.details.registration,
                              expression:
                                "details.documents_data.details.registration",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: {
                            value:
                              _vm.details.documents_data.details.registration,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.documents_data.details,
                                "registration",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v("Адрес для доставки"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.details.documents_data.details
                                  .delivery_data,
                              expression:
                                "details.documents_data.details.delivery_data",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: {
                            value:
                              _vm.details.documents_data.details.delivery_data,
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.details.documents_data.details,
                                "delivery_data",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.hasRole("runner")
                      ? _c("div", { staticClass: "col-md-6" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Код доступа"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.tablet_access.details
                                      .access_code,
                                  expression:
                                    "details.tablet_access.details.access_code",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.details.tablet_access.details.access_code,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.tablet_access.details,
                                    "access_code",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Код отчетности"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.tablet_access.details
                                      .report_code,
                                  expression:
                                    "details.tablet_access.details.report_code",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.details.tablet_access.details.report_code,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.tablet_access.details,
                                    "report_code",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Код блокировки"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.details.tablet_access.details
                                      .block_code,
                                  expression:
                                    "details.tablet_access.details.block_code",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text" },
                              domProps: {
                                value:
                                  _vm.details.tablet_access.details.block_code,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.details.tablet_access.details,
                                    "block_code",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(6),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", {}, [
                _vm.hasUploadedImages()
                  ? _c(
                      "div",
                      [
                        !_vm.showSavedImages
                          ? _c("LoadingButton", {
                              attrs: {
                                title: "Показать документы",
                                className: "btn btn-default",
                                onClick: _vm.getSavedPhotos,
                                loading: _vm.btnLoading,
                                color: _vm.$constants.SUCCESS_COLOR,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showSavedImages
                          ? _c("div", [
                              _c(
                                "div",
                                { staticClass: "flex flex-wrap" },
                                _vm._l(_vm.savedImages, function (img, index) {
                                  return _c(
                                    "div",
                                    { staticClass: "img_block" },
                                    [
                                      _c("img", {
                                        attrs: { src: img.url, alt: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.imageView(index)
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex flex-wrap" },
                  _vm._l(_vm.uploadedImages, function (img) {
                    return _c("div", { staticClass: "img_block" }, [
                      _c("img", { attrs: { src: img.url, alt: "" } }),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _c("label", [
                      _c(
                        "span",
                        {
                          staticClass: "btn btn-info",
                          attrs: { type: "button" },
                        },
                        [_vm._v("Выбрать новые документы для загрузки")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        ref: "uploadFilesInput",
                        staticClass: "input-file hidden",
                        attrs: {
                          type: "file",
                          id: "uploadPhotos",
                          multiple: "",
                          disabled: _vm.isSaving,
                          accept: "image/*",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.filesAdded(
                              $event.target.name,
                              $event.target.files
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.uploadedImages && _vm.uploadedImages.length
                      ? _c("LoadingButton", {
                          attrs: {
                            title: "Сохранить документы",
                            className: "btn btn-success",
                            onClick: _vm.uploadPhotos,
                            loading: _vm.btnLoading,
                            color: "white",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(7),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("CityProjectSelect", {
                  ref: "orderAccessSelected",
                  attrs: { selected: _vm.details.order_access.details },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-header flex justify-content-between" },
              [
                _c("h5", [_vm._v("Данные для начисления зарплаты")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: {
                      "header-btn btn": true,
                      "btn-default":
                        _vm.details.salary_details.details.use_salary,
                      "btn-success":
                        !_vm.details.salary_details.details.use_salary,
                    },
                    on: {
                      click: function ($event) {
                        _vm.details.salary_details.details.use_salary =
                          !_vm.details.salary_details.details.use_salary
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          !_vm.details.salary_details.details.use_salary
                            ? "Начислять зарплату"
                            : "Не начислять зарплату"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.details.salary_details.details.use_salary
              ? _c("div", [
                  _vm.hasRole("manager") ||
                  _vm.hasRole("postChiefRunner") ||
                  _vm.hasRole("supervisor") ||
                  _vm.hasRole("agentDivision") ||
                  _vm.hasRole("managerAssist") ||
                  _vm.hasRole("merchandiser")
                    ? _c("div", { staticClass: "card-body row m-0" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-4" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Базовая зарплата"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group mb-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.details.salary_details.details
                                        .base_salary,
                                    expression:
                                      "details.salary_details.details.base_salary",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number", placeholder: "Сумма" },
                                domProps: {
                                  value:
                                    _vm.details.salary_details.details
                                      .base_salary,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.details.salary_details.details,
                                      "base_salary",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "input-group-append" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.details.salary_details.details
                                            .base_currency,
                                        expression:
                                          "details.salary_details.details.base_currency",
                                      },
                                    ],
                                    staticClass: "custom-select",
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.$set(
                                          _vm.details.salary_details.details,
                                          "base_currency",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.$AllCurrencies,
                                    function (currency) {
                                      return _c(
                                        "option",
                                        { domProps: { value: currency.id } },
                                        [_vm._v(_vm._s(currency.currency))]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Коэффициент сдельной зарплаты"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group mb-1" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.details.salary_details.details.rate,
                                    expression:
                                      "details.salary_details.details.rate",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "number",
                                  placeholder: "Коэффициент",
                                },
                                domProps: {
                                  value:
                                    _vm.details.salary_details.details.rate,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.details.salary_details.details,
                                      "rate",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(
                                "Дивизион с которого будет списана зарплата"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group mb-1" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.details.salary_details.details
                                          .division_id,
                                      expression:
                                        "details.salary_details.details.division_id",
                                    },
                                  ],
                                  staticClass: "custom-select",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.details.salary_details.details,
                                        "division_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "0" } }, [
                                    _vm._v("Общий расход"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.$AllDivisions,
                                    function (division) {
                                      return _c(
                                        "option",
                                        { domProps: { value: division.id } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                (division.cities[0]?.city &&
                                                  division.cities[0]?.city
                                                    ?.name) ||
                                                  "Почта"
                                              ) +
                                              "\n                  (" +
                                              _vm._s(
                                                (division.user &&
                                                  division.user.short_name) ||
                                                  "не определен"
                                              ) +
                                              ")\n                "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Валюта выплаты зарплаты"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-group mb-1" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value:
                                        _vm.details.salary_details.details
                                          .pay_currency_id,
                                      expression:
                                        "details.salary_details.details.pay_currency_id",
                                    },
                                  ],
                                  staticClass: "custom-select",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.details.salary_details.details,
                                        "pay_currency_id",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                _vm._l(_vm.$AllCurrencies, function (currency) {
                                  return _c(
                                    "option",
                                    { domProps: { value: currency.id } },
                                    [_vm._v(_vm._s(currency.currency))]
                                  )
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Дата начала зачисления ЗП"),
                            ]),
                            _vm._v(" "),
                            _c("DateSelectProps", {
                              attrs: {
                                onSelect: (date) =>
                                  (_vm.details.salary_details.details.start_salary_date =
                                    _vm.moment(date, "YYYY-MM-DD")),
                                selectedDate: _vm.moment(
                                  _vm.details.salary_details.details
                                    .start_salary_date
                                ),
                                useDisabledDates: false,
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-8" }, [
                          _c(
                            "div",
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "badge badge-dark",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(
                                    "Выберите комбинации источников и направлений, по которым\n                начислется сдельная зарплата"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("CityProjectSelect", {
                                attrs: {
                                  selected:
                                    _vm.details.salary_directions.details,
                                  visibilitySelect: true,
                                  updateRecords: (records) =>
                                    _vm.updateSalaryDirections(
                                      records,
                                      "salary_directions"
                                    ),
                                },
                              }),
                              _vm._v(" "),
                              _c("ProjectDivisionSelect", {
                                attrs: {
                                  selected:
                                    _vm.details.salary_directions.details,
                                  visibilitySelect: true,
                                  updateRecords: (records) =>
                                    _vm.updateSalaryDirections(
                                      records,
                                      "salary_directions"
                                    ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "badge badge-dark",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(
                                    "Выберите комбинации источников и направлений, для игнорирования\n                при просчете"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("CityProjectSelect", {
                                attrs: {
                                  selected:
                                    _vm.details.ignore_salary_directions
                                      .details,
                                  updateRecords: (records) =>
                                    _vm.updateSalaryDirections(
                                      records,
                                      "ignore_salary_directions"
                                    ),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "badge badge-dark",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(
                                    "Выберите комбинации источников и направлений, для уникального\n                просчета"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("CityProjectSelect", {
                                attrs: {
                                  selected:
                                    _vm.details.salary_directions_custom_rate
                                      .details,
                                  visibilitySelect: true,
                                  useCustomRate: true,
                                  updateRecords: (records) =>
                                    _vm.updateSalaryDirections(
                                      records,
                                      "salary_directions_custom_rate"
                                    ),
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRole("runner") || _vm.hasRole("chiefRunner")
                    ? _c(
                        "div",
                        { staticClass: "card-body runner_salary_block" },
                        [
                          _c("div", { staticClass: "flex flex_gap" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex justify-content-between",
                                  },
                                  [
                                    _c("label", [_vm._v("Базовая ставка")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-group w-50" },
                                      [
                                        _vm._m(8),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.details.salary_details
                                                    .details.base_currency,
                                                expression:
                                                  "details.salary_details.details.base_currency",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  _vm.details.salary_details
                                                    .details,
                                                  "base_currency",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          _vm._l(
                                            _vm.$platformConstants
                                              .allowSalaryCurrencies,
                                            function (c) {
                                              return _c(
                                                "option",
                                                { domProps: { value: c.id } },
                                                [_vm._v(_vm._s(c.title))]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("SalaryBlock", {
                                  attrs: {
                                    salaryDetails:
                                      _vm.details.salary_details.details
                                        .runner_salary,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.details.salary_details.details
                                              .useChiefRunnerPayment,
                                          expression:
                                            "details.salary_details.details.useChiefRunnerPayment",
                                        },
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.details.salary_details.details
                                            .useChiefRunnerPayment
                                        )
                                          ? _vm._i(
                                              _vm.details.salary_details.details
                                                .useChiefRunnerPayment,
                                              null
                                            ) > -1
                                          : _vm.details.salary_details.details
                                              .useChiefRunnerPayment,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a =
                                              _vm.details.salary_details.details
                                                .useChiefRunnerPayment,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.details.salary_details
                                                    .details,
                                                  "useChiefRunnerPayment",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.details.salary_details
                                                    .details,
                                                  "useChiefRunnerPayment",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              _vm.details.salary_details
                                                .details,
                                              "useChiefRunnerPayment",
                                              $$c
                                            )
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(
                                      "\n                  Выплаты старшему курьеру"
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.details.salary_details.details
                                  .useChiefRunnerPayment
                                  ? _c("SalaryBlock", {
                                      attrs: {
                                        salaryDetails:
                                          _vm.details.salary_details.details
                                            .chief_runner_payment,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.details.salary_details.details
                                            .customSalaryCalculation,
                                        expression:
                                          "details.salary_details.details.customSalaryCalculation",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.details.salary_details.details
                                          .customSalaryCalculation
                                      )
                                        ? _vm._i(
                                            _vm.details.salary_details.details
                                              .customSalaryCalculation,
                                            null
                                          ) > -1
                                        : _vm.details.salary_details.details
                                            .customSalaryCalculation,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.details.salary_details.details
                                              .customSalaryCalculation,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.details.salary_details
                                                  .details,
                                                "customSalaryCalculation",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.details.salary_details
                                                  .details,
                                                "customSalaryCalculation",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.details.salary_details.details,
                                            "customSalaryCalculation",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(
                                    "\n                Индивидуальный просчет ЗП"
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.details.salary_details.details
                                .customSalaryCalculation
                                ? _c("SalaryBlock", {
                                    attrs: {
                                      salaryDetails:
                                        _vm.details.salary_details.details
                                          .custom_runner_salary,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          (_vm.cities && _vm.cities.length > 0) ||
                          (_vm.citiesSalary &&
                            Object.keys(_vm.citiesSalary).length > 0)
                            ? _c("div", [
                                _c("div", [
                                  _c("p", [
                                    _vm._v(
                                      "Добавить уникальный просчет зарплаты для выбранного города"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.cities.length
                                    ? _c("div", { staticClass: "flex mb-2" }, [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.selectedCityForSalary,
                                                expression:
                                                  "selectedCityForSalary",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            staticStyle: {
                                              "max-width": "300px",
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.selectedCityForSalary =
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          _vm._l(_vm.cities, function (city) {
                                            return _c(
                                              "option",
                                              { domProps: { value: city.id } },
                                              [_vm._v(_vm._s(city.name))]
                                            )
                                          }),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-info ml-2",
                                            on: { click: _vm.addCitySalary },
                                          },
                                          [_vm._v("Выбрать")]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _vm.citiesSalary &&
                                Object.keys(_vm.citiesSalary).length
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        _vm.citiesSalary,
                                        function (salary, cityId) {
                                          return _c(
                                            "div",
                                            { staticClass: "row m-0" },
                                            [
                                              _c("p", [
                                                _vm._v("Настройки ЗП для "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$AllCities[cityId]
                                                        .name
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "ml-2 btn btn-warning btn-xs",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteCitySalary(
                                                          cityId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("удалить")]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 salary_type",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v("Низкая ставка з/п"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.low.basic,
                                                            expression:
                                                              "salary.low.basic",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.low.basic,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.low,
                                                              "basic",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("+ сумма"),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.low.rate,
                                                            expression:
                                                              "salary.low.rate",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.low.rate,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.low,
                                                              "rate",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "+ (сумма-расходы) *"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.low
                                                                .expenses,
                                                            expression:
                                                              "salary.low.expenses",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.low.expenses,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.low,
                                                              "expenses",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [_vm._v("+")]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.low.bonus,
                                                            expression:
                                                              "salary.low.bonus",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.low.bonus,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.low,
                                                              "bonus",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "(ставка надбавки)"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 salary_type",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v("Дальняя ставка"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.mid.basic,
                                                            expression:
                                                              "salary.mid.basic",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.mid.basic,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.mid,
                                                              "basic",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("+ сумма"),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.mid.rate,
                                                            expression:
                                                              "salary.mid.rate",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.mid.rate,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.mid,
                                                              "rate",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "+ (сумма-расходы) *"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.mid
                                                                .expenses,
                                                            expression:
                                                              "salary.mid.expenses",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.mid.expenses,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.mid,
                                                              "expenses",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [_vm._v("+")]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.mid.bonus,
                                                            expression:
                                                              "salary.mid.bonus",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.mid.bonus,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.mid,
                                                              "bonus",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "(ставка надбавки)"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-12 salary_type",
                                                },
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      "Высокая ставка з/п"
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.high.basic,
                                                            expression:
                                                              "salary.high.basic",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.high.basic,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.high,
                                                              "basic",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v("+ сумма"),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.high.rate,
                                                            expression:
                                                              "salary.high.rate",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.high.rate,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.high,
                                                              "rate",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "+ (сумма-расходы) *"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.high
                                                                .expenses,
                                                            expression:
                                                              "salary.high.expenses",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.high
                                                              .expenses,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.high,
                                                              "expenses",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [_vm._v("+")]),
                                                      _vm._v(" "),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              salary.high.bonus,
                                                            expression:
                                                              "salary.high.bonus",
                                                          },
                                                        ],
                                                        staticClass:
                                                          "form-control",
                                                        attrs: {
                                                          type: "number",
                                                        },
                                                        domProps: {
                                                          value:
                                                            salary.high.bonus,
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            )
                                                              return
                                                            _vm.$set(
                                                              salary.high,
                                                              "bonus",
                                                              $event.target
                                                                .value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          "(ставка надбавки)"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-12 text-right" },
          [
            _vm.user.is_active
              ? [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Отправить в архив",
                      className: "btn btn-outline-warning",
                      onClick: () => _vm.updateUser("disable"),
                      loading: _vm.btnLoading,
                      color: _vm.$constants.WARNING_COLOR,
                    },
                  }),
                ]
              : [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Активировать",
                      className: "btn btn-outline-success",
                      onClick: () => _vm.updateUser("activate"),
                      loading: _vm.btnLoading,
                      color: _vm.$constants.SUCCESS_COLOR,
                    },
                  }),
                ],
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Сохранить",
                className: "btn btn-outline-success",
                onClick: () => _vm.updateUser(),
                loading: _vm.btnLoading,
                color: _vm.$constants.SUCCESS_COLOR,
              },
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Авторизация")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "mb-1" }, [
      _c(
        "a",
        { attrs: { href: "https://t.me/LogisticInfoBot", target: "_blank" } },
        [_vm._v("@LogisticInfoBot")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("Подключитесь к боту "),
      _c("strong", [_vm._v("@LogisticInfoBot")]),
      _vm._v(" в приложении Telegram."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Связь")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Дополнительно")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Документы и данные")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-12" }, [_c("hr")])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Доступ к проектам")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "input-group-prepend input-group-append" },
      [
        _c("span", { staticClass: "input-group-text m-0" }, [
          _vm._v("валюта ЗП"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }